import React from 'react';
import StatCard from '../../../../Components/StatCard/StatCard';
import { useSelector } from 'react-redux';

function DropTrackStats() {
    const dropTrackProduct = useSelector((state) => state.dropTrackProducts.dropTrackProduct.dropTrackProduct);

    return (
        <div className="grid grid-cols-3 gap-x-3 mx-5 mt-4">
            <StatCard 
                statName="DropTrack Watchers" 
                hasDecimal={true} 
                statValue={dropTrackProduct.dropWatch} 
            />
            <StatCard 
                statName="Page Visits in last 30 days" 
                hasDecimal={true} 
                statValue={dropTrackProduct.pageCount} 
            />
            <StatCard 
                statName="Cart Abandonments"
                statValue={0}
            />
        </div>
    );
}

export default DropTrackStats;
